"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onPlay;
function onPlay(event) {
  if (!this.config.autoplay && this.logger.times.LoadTimeVideo === -1) {
    this.logger.times.LoadTimeVideo = performance.now();
  }
  this._hideSpinnerClearDelay();
  this._playerState.playStartClockTime = 0;
  this.emit('play', event);
}